
const API_BASE_URL = 'https://print.michaelmelham.com/api';

const API_ENDPOINTS = {
  contacts: `${API_BASE_URL}/mappings/contacts`,
  upload: `${API_BASE_URL}/mappings/upload`,
  login: `${API_BASE_URL}/auth/login`,
  milestones: `${API_BASE_URL}/milesStone/addMilestoneAge`,
  milestoneAges: `${API_BASE_URL}/milesStone/getMilestoneAges`,
  dashboardRecords: `${API_BASE_URL}/mappings/dashboardRecords`
};

export default API_ENDPOINTS;
